// extracted by mini-css-extract-plugin
export default {"row":"SalesCard_row__QRJG0","title":"SalesCard_title__P0Ca-","value":"SalesCard_value__cY17B","unassigned":"SalesCard_unassigned__tYl3A"};